import { render, staticRenderFns } from "./apiDoc.vue?vue&type=template&id=44d654a9&scoped=true&"
import script from "./apiDoc.vue?vue&type=script&lang=js&"
export * from "./apiDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d654a9",
  null
  
)

export default component.exports